import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */

export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const getHomeRouteForLoggedInUser = () => {
  const userData = getUserData()

  if (userData && userData.role === 'tik_tok_manager') return { name: 'tiktok.brands.index' }
  if (userData && userData.role === 'tik_tok_uploader') return { name: 'tiktok.report-uploader.list.index' }
  if (userData) return { name: 'products' }
  return { name: 'login' }
}
